(function(){'use strict';function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}var euCountryCodes=["dk","fr","nl","be","at","it","es","pt","fi","se","pl","ie","lu","lv","lt","ee","mt","cy","sk","si","hr","bg","ro","cz","hu","gr"];function toggleDeliveryDependsOnMarket(){return _toggleDeliveryDependsOnMarket.apply(this,arguments)}function _toggleDeliveryDependsOnMarket(){return (_toggleDeliveryDependsOnMarket=_asyncToGenerator(_regenerator().m(function e(){var t,r,n,a,o,u,l;return _regenerator().w(function(e){for(;;)switch(e.n){case 0:try{if(t=document.querySelector("[data-market-handle]"),r=null,n="none",t)r=t.getAttribute("data-market-handle"),n="dom-attribute";else if(a=localStorage.getItem("userCountryCode"))try{o=JSON.parse(a).toLowerCase(),r="de"===o?"germany":euCountryCodes.includes(o)?"european-union":"international",n="country-fallback";}catch(e){r=null;}else r="international",n="default-fallback";document.documentElement.classList.remove("country-de","country-international"),u="country-international",l="non-eu",r&&"germany"===(l=getMarketCategory(r))&&(u="country-de"),document.documentElement.classList.add(u),window.dispatchEvent(new CustomEvent("marketCategoryChanged",{detail:{category:l,method:n,handle:r}})),document.documentElement.setAttribute("data-market-category",l);}catch(e){document.documentElement.classList.remove("country-de","country-international"),document.documentElement.classList.add("country-international"),document.documentElement.setAttribute("data-market-category","non-eu");}case 1:return e.a(2)}},e)}))).apply(this,arguments)}function getMarketCategory(e){if(!e)return "non-eu";var t=e.toLowerCase();if("germany"===t||"de"===t)return "germany";return ["european-union","denmark","france","netherlands","frankreich","spanien","italien","eu"].includes(t)||euCountryCodes.includes(t)?"eu":"non-eu"}window.mapCountryToMarketCategory=getMarketCategory,window.toggleDeliveryDependsOnCountry=toggleDeliveryDependsOnMarket,window.addEventListener("userLocationDetected",function(){toggleDeliveryDependsOnMarket();}),window.addEventListener("marketChanged",function(){toggleDeliveryDependsOnMarket();}),window.debugMarketDetection={getCurrentMarket:function(){var e=document.querySelector("[data-market-handle]");return e?e.getAttribute("data-market-handle"):"not-found"},getStoredCountry:function(){try{var e=localStorage.getItem("userCountryCode");return e?JSON.parse(e):"not-found"}catch(e){return "parse-error"}},getCurrentClasses:function(){return Array.from(document.documentElement.classList).filter(function(e){return e.startsWith("market-")||e.startsWith("country-")})},forceUpdate:function(){return toggleDeliveryDependsOnMarket()},testMarket:function(e){return getMarketCategory(e)},simulateMarkets:function(){return [{market:"germany",country:"de",expected:"germany",threshold:"€50"},{market:"european-union",country:"fr",expected:"eu",threshold:"€75"},{market:"denmark",country:"dk",expected:"eu",threshold:"€75"},{market:"international",country:"us",expected:"non-eu",threshold:"€100"},{market:"international",country:"eg",expected:"non-eu",threshold:"€100"},{market:"switzerland",country:"ch",expected:"non-eu",threshold:"€100"}].map(function(e){var t=getMarketCategory(e.market),r=getMarketCategory(e.country);return _objectSpread2(_objectSpread2({},e),{},{category:t,countryCategory:r,marketMatch:t===e.expected,countryMatch:r===e.expected})})},forceCountry:function(e){return localStorage.setItem("userCountryCode",JSON.stringify(e)),toggleDeliveryDependsOnMarket()},getDOMMarketData:function(){var e=document.querySelectorAll("[data-market-handle]"),t=document.querySelectorAll("[data-market-category]"),r=document.querySelectorAll(".delivery-cost, .delivery-cost-value");return {marketElements:Array.from(e).map(function(e){return {tagName:e.tagName,marketHandle:e.getAttribute("data-market-handle")}}),marketCategories:Array.from(t).map(function(e){return {tagName:e.tagName,marketCategory:e.getAttribute("data-market-category")}}),htmlClasses:document.documentElement.className,marketCategoryAttribute:document.documentElement.getAttribute("data-market-category"),deliveryCostElements:Array.from(r).map(function(e){var t=window.getComputedStyle(e);return {className:e.className,display:t.display}})}},checkCartDiscrepancy:function(){var e=document.querySelectorAll('.delivery-cost-value, [class*="free_shipping"]'),t=document.querySelectorAll('[class*="threshold"], [class*="delivery-cost"]'),r=document.querySelectorAll(".free-shipping-progress span"),n=document.documentElement.getAttribute("data-market-category"),a=100;return "germany"===n?a=50:"eu"===n&&(a=75),{cartTotals:["cart-drawer .totals__total-value","#main-cart-footer .totals__total-value",".cart-total","[data-cart-total]",".cart__footer .totals__total-value"].map(function(e){var t=document.querySelector(e);return {selector:e,text:t?t.textContent.trim():null}}),freeShippingElements:Array.from(e).map(function(e){return {className:e.className,text:e.textContent.trim()}}),thresholdElements:Array.from(t).map(function(e){return {className:e.className,text:e.textContent.trim()}}),progressBars:Array.from(r).map(function(e){var t=e.style.width,r=parseFloat(t);return {width:t,marketCategory:n,expectedThreshold:a,estimatedCart:r&&r<100?r/100*a:null,thresholdReached:100===r}})}}},toggleDeliveryDependsOnMarket();})();